import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaxDetailComponent } from './tax-detail.component';

@NgModule({
  declarations: [
    TaxDetailComponent
  ],
  exports: [
    TaxDetailComponent
  ],
  imports: [
    CommonModule
  ],
})
export class TaxDetailModule { }
